import React from 'react';
import { RichText } from '../types/content';
import { SourceRef } from './SourceRef';
export function RichTextView({
  text
}: {
  text: RichText;
}) {
  return <>
      {text.map((part, i) => typeof part === 'string' ? <React.Fragment key={i} data-id="element-505" data-mp="2edvs0re6a2fe">{part}</React.Fragment> : <SourceRef key={i} id={part.ref} estimate={part.estimate} data-id="element-506" data-mp="29fc26fwgk6hr" />)}
    </>;
}